try {
    if (process.env.TOKENS_FEATURE_FLAG === 'true' || process.env.STORYBOOK_TOKENS_FEATURE_FLAG !== 'false') require('./index-new.css');
    else require('./index.css');
  } catch (e) {
    if (e.code !== 'MODULE_NOT_FOUND') {
      throw e; // Re-throw unexpected errors
    }
    console.warn('index.css / index-new.css not found, proceeding without it.');
  }


import { jsx } from 'react/jsx-runtime';
import { Chip } from '@design-system/chip';
import { Container } from '@design-system/container';
import { forwardRef } from 'react';

const ChipPanel = forwardRef(({ handleFilterChange, filter, showChipPanel }, ref) => showChipPanel && filter.length > 0 ? (jsx(Container, Object.assign({ maxWidth: "max-grid", className: "cds-chip-panel", ref: ref }, { children: filter.map(({ group, value, label }) => (jsx(Chip, { onClick: () => handleFilterChange(group, value, label), text: label, isSelected: true }, value.uid))) }))) : null);

export { ChipPanel };
